var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.517,
    height: 27.23,
    viewBox: "0 0 25.517 27.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1466.057 -5306.724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1466.318 5306.996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4,26.708a.537.537,0,0,1-.516-.681l2.768-9.87H.537A.537.537,0,0,1,.1,15.3L11.082.219a.541.541,0,0,1,.667-.167.536.536,0,0,1,.282.628L9.263,10.55H14.38a.537.537,0,0,1,.433.852L3.835,26.486a.537.537,0,0,1-.435.221M1.59,15.083H6.36a.537.537,0,0,1,.517.681L4.724,23.442l8.6-11.82H8.556a.536.536,0,0,1-.516-.68l2.152-7.679Z",
    transform: "translate(0.001 0.001)",
    fill: "#0aadfd",
    stroke: "#0aadfd",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1482.772 5306.996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.948,15.3a.308.308,0,0,1-.3-.39L3.238,9.255H.307a.307.307,0,0,1-.249-.488L6.348.125a.31.31,0,0,1,.382-.1.307.307,0,0,1,.162.36L5.306,6.043H8.237a.308.308,0,0,1,.248.488L2.2,15.173a.308.308,0,0,1-.249.127M.911,8.64H3.643a.307.307,0,0,1,.3.39l-1.233,4.4L7.634,6.658H4.9a.307.307,0,0,1-.3-.39l1.233-4.4Z",
    transform: "translate(0.001 0.001)",
    fill: "#002a2e",
    stroke: "#002a2e",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.709439518b00046361aa81b5f1b61cb9.svg";
export { ForwardRef as ReactComponent };